import { fallback } from '@enum/image'

export const captchaImageSource = captchaImage =>
  // The first render precedes the asynchronous captcha response.
  captchaImage ? `data:image/png;base64,${captchaImage}` : fallback
